<template>
  <content-layout>
    <div slot="content_container">
      <div class="row mt-4">
        <div class="col-1 desktop"></div>

        <!-- content section-->
        <section
            class="col-9"
            :class="{'col-12': windowWidth <= 1200}"
            style="text-align: left">
          <!-- search by -->
          <search-by-card
            :_disabled="mReport.isScanning()"
            :_on-click-cb="onSearchAccount">
          </search-by-card>
          <!-- search result -->
          <div v-if="mSearchBy.data.result">
            <!-- Account details -->
            <div>
              <label class="label">Account Detail: <label v-if="!mSearchBy.isValid()" class="warning" style="font-weight: lighter">Customer not found</label></label>
              <div class="card">
                <div class="card-body">
                  <div class="row"
                       v-for="(data, dataIndex) in mSearchBy.data.result.formattedAccountDetail()"
                       v-bind:key="dataIndex">
                    <div class="col-6 description" :class="{'col-12' : data.length == 1}"
                         v-for="(item, itemIndex) in data" v-bind:key="itemIndex">
                      <span class="label">{{ item.text }}</span>
                      <span v-if="!item.multiple"> {{ item.value }}</span>
                      <span v-else>
                          <span class="ml-1">
                            <b-icon v-bind:icon="item.value[0].icon" v-bind:style="item.value[0].style">
                            </b-icon> {{ item.value[0].text }}
                          </span>
                          <span class="ml-2">
                            <b-icon v-bind:icon="item.value[1].icon" v-bind:style="item.value[1].style">
                            </b-icon> {{ item.value[1].text }}
                          </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="width: 100%; height: 1px; background-color: var(--primary-highlight-background); "></div>
            <!-- start scan form -->
            <!-- Last diagnostics -->
            <form v-if="mSearchBy.isValid()" class="mt-2 form-group" v-on:submit.prevent="onStartDiagnostics">
              <!-- scan button -->
              <div class="d-flex flex-row justify-content-end">
                <div class="checkbox mr-1 d-flex flex-column">
                  <label class="m-auto">
                    <input
                        type="checkbox"
                        v-model="mReport.option.skipOnt.value"
                        v-bind:disabled="mReport.isScanning()">
                    {{ mReport.option.skipOnt.text }}
                  </label>
                </div>
                <button type="submit"
                        class="btn btn-outline-primary ml-2"
                        style="width: 10rem;"
                        v-bind:disabled="mReport.isScanning()">
                  {{ 'Run Test'}}
                </button>
              </div>

              <!-- scanning progress bar -->
              <div v-if="mReport.isScanning() || mReport.isLatest()" class="progress mt-4">
                <div class="progress-bar progress-bar-striped active" role="progressbar"
                     v-bind:valuenow="mReport.data.progress" aria-valuemin="0" aria-valuemax="100" v-bind:style="progressStyle">
                  {{ mReport.data.progress }}%
                </div>
              </div>
              <div class="mt-1">
                <div v-if="mReport.isScanning()"
                     class="small btn-warning pl-2">
                  Please wait while scanning is in progress, may take up to {{ mSearchBy.data.result.isNgaOrNorthPower() ? '30' : '60' }} seconds.
                </div>
                <div v-else-if="mReport.isError()"
                     class="small btn-danger pl-2">
                  Diagnostics failed.
                </div>
                <div v-else-if="mReport.isLatest()"
                     class="small btn-info pl-2">
                  Diagnostics success.
                </div>
                <div v-else-if="mReport.isScanningBlocked()"
                     class="small btn-info pl-2">
                  It appears a scan request is in progress, please try again later
                </div>
              </div>

              <div style="padding: 0.5rem 0">
                <span style="font-weight: bold">Last Diagnostics Test:</span>
                {{ mReport.isScanning() ? 'Scanning...' : mReport.isScanningBlocked() ? '---' : lastReportDateTime }}
              </div>
            </form>
          </div>


          <!-- report result -->
          <section v-if="mReport.isValid()">

            <!-- radius status -->
            <div class="mt-4">
              <label class="label">Radius Status:</label>
              <div class="card">
                <div class="card-body">
                  <div class="row"
                       v-for="(data, dataIndex) in mReport.data.result.formattedRadiusStatus()"
                       v-bind:key="dataIndex">
                    <div class="col-6 description" :class="{'col-12' : data.length == 1}"
                         v-for="(item, itemIndex) in data" v-bind:key="itemIndex">
                      <span class="label">{{ item.text }}</span>
                      <span v-if="!item.multiple">
                        <span v-if="item.style" :style=item.style> {{ item.value }}</span>
                        <span v-else> {{ item.value }}</span>
                        <img v-if="item.img"
                             class="ml-1"
                             style="width: 28px; height: 12px; object-fit: contain" alt="provider"
                             :src="require(`@/assets/images/${item.img}`)">
                      </span>
                      <span v-else>
                        <span class="ml-1">
                          <b-icon v-bind:icon="item.value[0].icon" v-bind:style="item.value[0].style">
                          </b-icon> {{ item.value[0].text }}
                        </span>
                        <span class="ml-2">
                          <b-icon v-bind:icon="item.value[1].icon" v-bind:style="item.value[1].style">
                          </b-icon> {{ item.value[1].text }}
                        </span>
                        <span v-if="item.value.length > 2" class="ml-2">
                          {{ item.value[2].text }}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- ONT Results -->
            <div class="mt-4">
              <label class="label">Ont Results:</label>
              <div class="card">
                <div class="card-body">
                  <div class="row"
                       v-for="(data, dataIndex) in mReport.data.result.formattedOntResults()"
                       v-bind:key="dataIndex">
                    <div class="col-6 description" :class="{'col-12' : data.length == 1}"
                         v-for="(item, itemIndex) in data" v-bind:key="itemIndex">
                      <span class="label">{{ item.text }}</span>
                      <span v-if="!item.multiple">
                        <span v-if="item.style" :style=item.style> {{ item.value }}</span>
                        <span v-else> {{ item.value }}</span>
                      </span>
                      <span v-else>
                          <span class="ml-1">
                            <b-icon v-bind:icon="item.value[0].icon" v-bind:style="item.value[0].style">
                            </b-icon> {{ item.value[0].text }}
                          </span>
                          <span class="ml-2">
                            <b-icon v-bind:icon="item.value[1].icon" v-bind:style="item.value[1].style">
                            </b-icon> {{ item.value[1].text }}
                          </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- voice status -->
            <div v-if="mReport.data.result.hasAtaVoice()" class="mt-4">
              <label class="label">Voice Status:</label>
              <div class="card">
                <div class="card-body">
                  <div class="row"
                       v-for="(data, dataIndex) in mReport.data.result.formattedVoiceStatus()"
                       v-bind:key="dataIndex">
                    <div class="col-6 description" :class="{'col-12' : data.length == 1}"
                         v-for="(item, itemIndex) in data" v-bind:key="itemIndex">
                      <span class="label">{{ item.text }}</span>
                      <span v-if="!item.multiple"> {{ item.value }}</span>
                      <span v-else>
                          <span class="ml-1">
                            <b-icon v-bind:icon="item.value[0].icon" v-bind:style="item.value[0].style">
                            </b-icon> {{ item.value[0].text }}
                          </span>
                          <span class="ml-2">
                            <b-icon v-bind:icon="item.value[1].icon" v-bind:style="item.value[1].style">
                            </b-icon> {{ item.value[1].text }}
                          </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Network Detail -->
            <div class="mt-4">
              <label class="label">Network Detail:</label>
              <div class="card">
                <div class="card-body">
                  <net-work-map
                      :_networkState="mReport.data.result.formattedNetworkMapState()">

                  </net-work-map>
                </div>
              </div>
            </div>

            <!-- Usage Information -->
            <div class="mt-4">
              <label class="label">Usage Information (GB):</label>
              <div class="card">
                <div class="card-body">
                  <net-work-usage-graph :data="mReport.data.result.formattedUsageData()">
                  </net-work-usage-graph>
                </div>
              </div>
            </div>

          </section>

        </section>
        <div class="col-2 desktop"></div>
      </div>
    </div>
  </content-layout>
</template>

<script>
import webapi from "@/webapi"
import model from "@/model"
import ContentLayout from "@/components/content_layout"
import SearchByCard from "@/views/content/components/search_by_card"
import NetWorkMap from "@/views/content/components/network_map"
import NetWorkUsageGraph from "@/views/content/components/network_usage_graph"
import displayHelper from "@/util/display_helper"
import logger from "@/util/logger"

const LOG_TAG = 'diagnostics';

export default {
  name: LOG_TAG,
  display: 'Diagnostics',
  route: `customer_services.${LOG_TAG}`,
  components: {
    ContentLayout,
    SearchByCard,
    NetWorkMap,
    NetWorkUsageGraph
  },
  data() {
    return {
      mSearchBy: {
        data: {
          providerAccountId: '',
          houseNumber: '',
          accountNumber: '',
          result: null,
        },
        isValid() {
          return this.data.result && this.data.result.isValid();
        },
        clear() {
          this.data.result = null;
        }
      },
      mReport: {
        option: {
          skipOnt: {
            key: 'skip_ont',
            text: 'Skip Ont',
            value: false,
          },
        },
        scanOption: {
          interval: 1000, // 1 seconds
          pollDuration: displayHelper.POLL_DURATION,
        },
        data: {
          isScanning: false,
          isScanningBlocked: false,
          progress: 0,
          progressCountdown: 0,
          pollCountDown: 0,
          result: null,
          error: false,
          latest: false,
        },
        isValid() {
          return this.data.result && this.data.result.isValid();
        },
        isScanning() {
          return this.data.isScanning;
        },
        isScanningBlocked() {
          return this.data.isScanningBlocked;
        },
        isError() {
          return this.data.error;
        },
        isLatest() {
          return this.data.latest;
        },
        clear() {
          this.data.isScanning = false;
          this.data.isScanningBlocked = false;
          this.data.progress = 0;
          this.data.progressCountdown = 0;
          this.data.pollCountDown = 0;
          this.data.result = null;
          this.data.error = false;
          this.data.latest = false;
        }
      }
    };
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    progressStyle() {
      return {
        width: `${this.mReport.data.progress}%`,
      };
    },
    lastReportDateTime() {
      const vm = this;
      if (vm.mReport.data.result) {
        return vm.mReport.data.result.formattedLastReportTime();
      } else if (vm.mSearchBy.data.result) {
        return vm.mSearchBy.data.result.formattedLastReportTime();
      }
      return '---';
    }
  },
  mounted() {
  },
  methods: {
    onSearchAccount(data) {
      const vm = this;
      logger.d(LOG_TAG, 'onSearchAccount', data);
      vm.mReport.clear();
      vm.mSearchBy.data = data;
      if (data.providerAccountId) {
        webapi.diagnosticsService.getLastDiagnosticsResultByAccountId(
            data.providerAccountId,
            (response) => {
              logger.d(LOG_TAG, 'onSearchAccount', response);
              // apply to model with help functions
              let modelData = model.diagnosticsServiceTestResponse(response).setAccountId(
                data.providerAccountId);
              logger.d(LOG_TAG, 'onSearchAccount', modelData);
              vm.mSearchBy.data.result = modelData;
              vm.mReport.data.result = modelData;
            },
            (error) => {
              logger.w(LOG_TAG, 'onSearchAccount', error.data);
              let modelData = model.diagnosticsServiceTestResponse();
              vm.mSearchBy.data.result = modelData;
              vm.mReport.data.result = modelData;
            }
        )
      } else {
        webapi.diagnosticsService.getLastDiagnosticsResultByHouseAndAccountNumber(
            data.houseNumber,
            data.accountNumber,
            (response) => {
              logger.d(LOG_TAG, 'onSearchAccount', response);
              // apply to model with help functions
              let modelData = model.diagnosticsServiceTestResponse(response).setHouseAccountNumber(
                data.houseNumber,
                data.accountNumber);
              logger.d(LOG_TAG, 'onSearchAccount', modelData.getInternetUsage());

              vm.mSearchBy.data.result = modelData;
              vm.mReport.data.result = modelData;

            },
            (error) => {
              logger.w(LOG_TAG, 'onSearchAccount', error.data);
              let modelData = model.diagnosticsServiceTestResponse();
              vm.mSearchBy.data.result = modelData;
              vm.mReport.data.result = modelData;
            }
        )
      }
    },
    onStartDiagnostics() {
      const vm = this;
      logger.d(LOG_TAG, 'onStartDiagnostics', vm.mReport.option.skipOnt.value);
      const accountId = vm.mSearchBy.data.result.providerAccountId;
      const houseNumber = vm.mSearchBy.data.result.houseNumber;
      const accountNumber = vm.mSearchBy.data.result.accountNumber
      if (accountId) {
        webapi.diagnosticsService.getLastDiagnosticsResultByAccountId(
            accountId,
          (data) => {
            const modelData = model.diagnosticsServiceTestResponse(data).setAccountId(accountId);
            vm.startCountdown(modelData.getScanTimeout(), modelData.getPollCountDown());
            if (modelData.getIsScanInProgress()) {
              vm.mReport.data.isScanningBlocked = true;
            } else {
              webapi.diagnosticsService.startDiagnosticsByAccountId(
                accountId,
                vm.mReport.option.skipOnt.value,
                (data) => {
                  vm.onHandleScanSuccess(data);
                },
                (error) => {
                  vm.onHandleScanError(error)
                },
              )
            }
          },
          (error) => {
            logger.w(LOG_TAG, 'onStartDiagnostics', error);
            let modelData = model.diagnosticsServiceTestResponse({});
            vm.mReport.data.result = modelData;
            vm.mReport.data.error = true;
            vm.mReport.data.latest = true;
          },

        )
      } else {
        webapi.diagnosticsService.getLastDiagnosticsResultByHouseAndAccountNumber(
          houseNumber,
          accountNumber,
          (data) => {
            const modelData = model.diagnosticsServiceTestResponse(data).setHouseAccountNumber(houseNumber, accountNumber);
            vm.startCountdown(modelData.getScanTimeout(), modelData.getPollCountDown());
            if (modelData.getIsScanInProgress()) {
              vm.mReport.data.isScanningBlocked = true;
            } else {
              webapi.diagnosticsService.startDiagnosticsByHouseAndAccountNumber(
                houseNumber,
                accountNumber,
                vm.mReport.option.skipOnt.value,
                (data) => {
                  vm.onHandleScanSuccess(data);
                },
                (error) => {
                  vm.onHandleScanError(error);
                },
              )
            }
          },
          (error) => {
            logger.w(LOG_TAG, 'onStartDiagnostics', error);
            let modelData = model.diagnosticsServiceTestResponse({});
            vm.mReport.data.result = modelData;
            vm.mReport.data.error = true;
            vm.mReport.data.latest = true;
          }
        )
      }
    },
    onHandleScanSuccess(data) {
      const vm = this;
      logger.d(LOG_TAG, 'onHandleScanSuccess');

      let modelData = model.diagnosticsServiceTestResponse(data);
      vm.mReport.data.result = modelData;
      vm.mReport.data.latest = true;

    },
    pollScanInProgressByAccountId(accountId, onScanResult) {
      const vm = this;
      let timerId = setInterval(() => {
        webapi.diagnosticsService.getLastDiagnosticsResultByAccountId(
          accountId,
          (data) => {
            vm.mReport.data.pollCountDown -= vm.mReport.scanOption.pollDuration;
            const modelData = model.diagnosticsServiceTestResponse(data).setAccountId(accountId);
            logger.d(LOG_TAG, 'pollScanInProgressByAccountId', 'scanning', modelData.getIsScanInProgress(), vm.mReport.data.pollCountDown);
            if (!modelData.getIsScanInProgress()) {
              clearInterval(timerId);
              onScanResult(true, data);
            } else if (vm.mReport.data.pollCountDown <= 0) {
              clearInterval(timerId);
              onScanResult(false);
            }
          },
          (error) => {
            logger.w(LOG_TAG, 'pollScanInProgressByAccountId', error);
            clearInterval(timerId);
            onScanResult(false);
          },
        )
      }, vm.mReport.scanOption.pollDuration);
    },
    pollScanInProgressByHouseAccountNumber(houseNumber, accountNumber, onScanResult) {
      const vm = this;
      let timerId = setInterval(() => {
        webapi.diagnosticsService.getLastDiagnosticsResultByHouseAndAccountNumber(
            houseNumber,
            accountNumber,
            (data) => {
              vm.mReport.data.pollCountDown -= vm.mReport.scanOption.pollDuration;
              const modelData = model.diagnosticsServiceTestResponse(data).setHouseAccountNumber(houseNumber, accountNumber);
              logger.d(LOG_TAG, 'pollScanInProgressByHouseAccountNumber', 'scanning', modelData.getIsScanInProgress(), vm.mReport.data.pollCountDown);
              if (!modelData.getIsScanInProgress()) {
                clearInterval(timerId);
                onScanResult(true, data);
              } else if (vm.mReport.data.pollCountDown <= 0) {
                clearInterval(timerId);
                onScanResult(false);
              }
            },
            (error) => {
              logger.w(LOG_TAG, 'pollScanInProgressByHouseAccountNumber', error);
              clearInterval(timerId);
              onScanResult(false);
            },
        )
      }, vm.mReport.scanOption.pollDuration);
    },
    onHandleScanError(error) {
      const vm = this;
      logger.w(LOG_TAG, 'onHandleScanFailed', error);
      // scan error validate if polling is required
      const accountId = vm.mSearchBy.data.result.providerAccountId;
      const houseNumber = vm.mSearchBy.data.result.houseNumber;
      const accountNumber = vm.mSearchBy.data.result.accountNumber
      logger.d(LOG_TAG, 'onHandleScanFailed', 'pollScanInProgressByAccountId');
      if (accountId) {
        vm.pollScanInProgressByAccountId(
          accountId,
          (result, data) => {
            logger.d(LOG_TAG, 'onHandleScanFailed', 'result', result);
            if (result) {
              vm.onHandleScanSuccess(data);
            } else {
              let modelData = model.diagnosticsServiceTestResponse({});
              vm.mReport.data.result = modelData;
              vm.mReport.data.error = true;
              vm.mReport.data.latest = true;
            }
          })
      } else {
        vm.pollScanInProgressByHouseAccountNumber(
            houseNumber,
            accountNumber,
            (result, data) => {
              logger.d(LOG_TAG, 'onHandleScanFailed', 'result', result);
              if (result) {
                vm.onHandleScanSuccess(data);
              } else {
                let modelData = model.diagnosticsServiceTestResponse({});
                vm.mReport.data.result = modelData;
                vm.mReport.data.error = true;
                vm.mReport.data.latest = true;
              }
            })
      }
    },
    startCountdown(timeout, pollCountDown) {
      const vm = this;
      logger.d(LOG_TAG, 'startCountdown', timeout);
      vm.mReport.data.result = null;
      vm.mReport.data.error = false;
      vm.mReport.data.isScanningBlocked = false;
      vm.mReport.data.isScanning = true;
      vm.mReport.data.progress = 0;
      vm.mReport.data.progressCountdown = timeout;
      vm.mReport.data.pollCountDown = pollCountDown;
      logger.d(LOG_TAG, 'startCountdown', vm.mReport.scanOption.interval, timeout);
      // repeat with the interval of 2 seconds
      let timerId = setInterval(() => {
        vm.mReport.data.progressCountdown -= vm.mReport.scanOption.interval;
        let progress = (100 - (vm.mReport.data.progressCountdown / timeout * 100));

        if (vm.mReport.data.result) {
          // if data has no error progress to 100 else stay where it was
          if (!vm.mReport.isError()) {
            progress = 100;
          } else {
            progress = parseInt(vm.mReport.data.progress);
          }
        } else {
          // max out at 99% if takes longer than expected
          progress = progress > 95 ? 97 : progress;
        }
        vm.mReport.data.progress = progress.toFixed(0);

        logger.d(LOG_TAG, 'countDown', vm.mReport.data.progress, 'data', null!=vm.mReport.data.result);
        // count down till we have report data
        if (vm.mReport.data.result) {
          clearInterval(timerId);
          vm.mReport.data.isScanning = false;
        } else if (vm.mReport.isScanningBlocked()) {
          clearInterval(timerId);
          vm.mReport.data.isScanning = false;
        }
      }, vm.mReport.scanOption.interval);
    }
  }
}
</script>

<style scoped>
.warning {
  color: var(--indicator-red);
}
.label {
  font-weight: bold;
}
.description {
  font-weight: lighter;
  font-size: smaller;
}
.desktop {
  display: block;
}
@media screen and (max-width: 1200px) {
  .desktop {
    display: none;
  }
}
</style>
